var symbioticTabs = {
  init: function () {
    $('[data-symbiotic-tabs]').each(function () {
      var $section = $(this);

      function setActive(blockId) {
        if (!blockId) return;

        $section.find('[data-symbiotic-trigger]').each(function () {
          var $button = $(this);
          var isActive = String($button.data('symbiotic-trigger')) === String(blockId);

          $button.toggleClass('active', isActive);
          $button.attr('aria-pressed', isActive);
        });

        $section.find('[data-symbiotic-panel]').each(function () {
          var $panel = $(this);
          var isActive = String($panel.data('symbiotic-panel')) === String(blockId);

          $panel.toggleClass('active', isActive);
          $panel.attr('aria-hidden', !isActive);

          $panel.find('video').each(function () {
            if (isActive) {
              this.play().catch(function () {});
            } else {
              this.pause();
            }
          });
        });
      }

      $section
        .find('[data-symbiotic-trigger]')
        .off('click.symbioticTabs')
        .on('click.symbioticTabs', function () {
          setActive($(this).data('symbiotic-trigger'));
        });

      setActive($section.find('[data-symbiotic-trigger]').first().data('symbiotic-trigger'));
    });
  }
};

$(document).ready(function () {
  symbioticTabs.init();
});

$(document).on('shopify:section:load', function () {
  symbioticTabs.init();
});
